import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Header from "../components/Header";
import Footer from "../components/Footer";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Clients from "../pages/Clients";
import Portfolio from "../pages/Portfolio";
import Services from "../pages/Services";
import EnterpriseNetworking from "../pages/services/EnterpriseNetworking";
import Cybersecurity from "../pages/services/Cybersecurity";
import CollaborationServices from "../pages/services/CollaborationServices";
import DataCenter from "../pages/services/DataCenter";
import ManagedServices from "../pages/services/ManagedServices";
import ProfessionalServices from "../pages/services/ProfessionalServices";
import Sustainability from "../pages/Sustainability";
import DiversityInclusion from "../pages/DiversityInclusion";
import Career from "../pages/Career";
import Industries from "../pages/Industries";
import Partners from "../pages/Partners";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndConditions";
import WebsiteDevelopmentBlog from "../pages/blogs/WebsiteDevelopmentBlog";
import Blogs from "../pages/Blogs";
import CaseStudy from "../pages/CaseStudy";


const Router = () => {

    const [headerData, setHeaderData] = useState([]);

    return (
        <BrowserRouter>

            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/services/enterprise-networking" element={<EnterpriseNetworking />} />
                <Route path="/services/cyber-security" element={<Cybersecurity />} />
                <Route path="/services/collaboration-services" element={<CollaborationServices />} />
                <Route path="/services/data-center" element={<DataCenter />} />
                <Route path="/services/managed-services" element={<ManagedServices />} />
                <Route path="/services/professional-services" element={<ProfessionalServices />} />
                <Route path="/sustainability" element={<Sustainability />} />
                <Route path="/diversity-inclusion" element={<DiversityInclusion />} />
                <Route path="/career" element={<Career />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/blog" element={<WebsiteDevelopmentBlog />} />
                {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
                {/* <Route path="/terms" element={<TermsAndConditions />} /> */}
                {/* <Route path="/case-study" element={<CaseStudy />} /> */}
                <Route path="/blogs" element={<Blogs />} />
                <Route path="*" element={<Home />} />

            </Routes>
            <Footer headerData={headerData} />
        </BrowserRouter >


    )
}
export default Router;